<template>
  <div v-if="isLoaded" id="Financing">
    <Hero class="lift" :formats="['webp']" src="../../../assets/financing-hero.jpg">
      <h1>{{ financing.title }}</h1>
    </Hero>
    <SectionInBank v-if="isInBank" />
    <SectionCitadele v-if="isCitadele" />
    <section id="content">
      <Wrap :class="wrapClasses[bankName.toLowerCase()] || ''">
        <Markdown
          :hasStyles="true"
          :markdown="financing.content" />
        <Row v-if="!bankName" class="banks">
          <Column
            v-for="bank in banks"
            :key="bank"
            class="bank fill"
            :lg="~~(12 / banks.length)"
            :md="4">
            <Route
              :params="{ slug: bank }"
              :title="bank | capitalize"
              to="FinancingBank">
              <div class="picContainer">
                <Pic
                  v-if="bank === 'inbank' || bank === 'luminor'"
                  :alt="bank | capitalize"
                  :src="`${basePath}assets/banks/${bank}-logo.svg`" />
                <Pic
                  v-else
                  :alt="bank | capitalize"
                  :formats="['webp']"
                  :src="`${basePath}assets/banks/${bank}-logo.png`" />
              </div>
              <Btn>
                {{ $t('more') }}
              </Btn>
            </Route>
          </Column>
        </Row>
      </Wrap>
    </section>
    <SectionBigBank v-if="isBigBank" />
    <SectionLuminor v-if="isLuminor" />
  </div>
</template>

<script>
import { actions, getters } from 'views/utils'
import Hero from 'views/components/Hero'
import Meta from 'views/mixins/Meta'
import SectionBigBank from 'views/components/SectionBigBank'
import SectionCitadele from 'views/components/SectionCitadele'
import SectionInBank from 'views/components/SectionInBank'
import SectionLuminor from 'views/components/SectionLuminor'

const Markdown = () => import(/* webpackChunkName: 'showdown' */ 'views/components/Markdown')

export default {
  mixins: [
    Meta(
      undefined,
      ({ financing }) => financing?.content,
      require('@/assets/social/financing.jpg'),
    ),
  ],
  components: { Hero, Markdown, SectionBigBank, SectionInBank, SectionCitadele, SectionLuminor },
  data() {
    return {
      banks: [
        'bigbank',
        'swedbank',
        'inbank',
        'citadele',
        'luminor',
      ],
      wrapClasses: {
        citadele: 'lg',
      },
    }
  },
  computed: {
    bankName() {
      return (this.$route.params.slug || '').toUpperCase()
    },
    financing() {
      const type = `FINANCING${this.bankName ? `_${this.bankName}` : ''}`

      return this.query('page', {
        locale: this.locale,
        type,
      }, true)
    },
    isBigBank() {
      return this.bankName === 'BIGBANK'
    },
    isInBank() {
      return this.bankName === 'INBANK'
    },
    isCitadele() {
      return this.bankName === 'CITADELE'
    },
    isLuminor() {
      return this.bankName === 'LUMINOR'
    },
    ...getters('basePath'),
  },
  methods: actions('FETCH_PAGE'),
  created() {
    this.LOAD(this.FETCH_PAGE())
  },
}
</script>

<style lang="scss">
#Financing {
  .Hero {
    .image img {
      filter: brightness(0.7);
    }
  }

  #content {
    background-color: $white;

    .banks {
      display: flex;
      justify-content: center;
      margin: 4rem 0;
      text-align: center;

      .bank {
        display: flex;
        justify-content: center;
        min-width: 160px;
      }

      .Btn {
        padding: 1rem;
      }

      .picContainer {
        align-items: center;
        display: grid;
        min-height: 6rem;
      }

      a {
        display: inline-block;
        margin-right: 2rem;
        // min-width: 300px;
        padding: 1rem 0;
        text-align: center;

        .Pic {
          display: flex;
          justify-content: center;

          img {
            display: block;
            margin-bottom: 2rem;
            // max-height: 5rem;
            max-width: 8rem;
          }
        }

      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "more": "More information"
  },
  "lt": {
    "meta": {
      "title": {
      "complement": "Nogrid",
      "inner": "Paskolos saulės elektrinėms",
      "separator": "-"
      }
    },
    "more": "Daugiau informacijos",
    "ctaLuminor": "Pildyti paraišką"
  },
  "pl": {
    "more": "Więcej informacji"
  }
}
</i18n>
